module.exports = __webpack_public_path__ + "static/media/no_sound.163480da.png";